import { FileSearch, ShieldCheck } from "lucide-react";

const FIELDS = [
    { k: "Document type", v: "Commercial loan agreement", conf: 99 },
    { k: "Counterparty", v: "Northwind Logistics LLC", conf: 97 },
    { k: "Principal amount", v: "$2,400,000", conf: 98 },
    { k: "Covenant — DSCR", v: "≥ 1.25×", conf: 92 },
    { k: "Maturity date", v: "2029-06-30", conf: 95 },
];

/**
 * Reusable "DocuIQX" document-extraction mockup.
 */
export default function DocExtractionPanel({ className = "" }) {
    return (
        <div
            className={`rounded-2xl bg-white border border-[#303030]/10 shadow-[0_30px_70px_-40px_rgba(0,0,0,0.55)] overflow-hidden ${className}`}
            data-testid="mockup-doc-extraction"
            aria-hidden="true"
        >
            <div className="flex items-center justify-between px-4 py-3 border-b border-[#303030]/8 bg-[#FAFAF8]">
                <div className="flex items-center gap-2">
                    <span className="w-6 h-6 grid place-items-center rounded-md bg-[#FF4040]/12 text-[#FF4040]">
                        <FileSearch className="w-3.5 h-3.5" />
                    </span>
                    <span className="text-[12px] font-semibold text-[#303030]">DocuIQX · Extraction</span>
                </div>
                <span className="font-mono text-[10px] text-[#303030]/55">page 1 / 14</span>
            </div>

            <div className="grid grid-cols-[0.8fr_1.2fr]">
                {/* Document scan column */}
                <div className="relative border-r border-[#303030]/8 p-3 bg-[#FAFAF8] overflow-hidden">
                    <div className="space-y-1.5">
                        {[80, 95, 60, 88, 72, 92, 50, 84, 66, 90].map((w, i) => (
                            <div
                                key={i}
                                className="h-1.5 rounded-full bg-[#303030]/10"
                                style={{ width: `${w}%` }}
                            />
                        ))}
                    </div>
                    {/* scanning line */}
                    <div className="absolute left-2 right-2 h-7 pqx-anim-scan rounded bg-gradient-to-b from-[#FF4040]/0 via-[#FF4040]/15 to-[#FF4040]/0 border-y border-[#FF4040]/40" />
                </div>

                {/* Extracted fields */}
                <ul className="divide-y divide-[#303030]/6">
                    {FIELDS.map((f, i) => (
                        <li key={f.k} className="px-3.5 py-2 pqx-pop-in" style={{ animationDelay: `${i * 110}ms` }}>
                            <p className="text-[9.5px] uppercase tracking-[0.14em] text-[#303030]/50">{f.k}</p>
                            <div className="flex items-center justify-between gap-2 mt-0.5">
                                <p className="text-[12px] font-semibold text-[#303030] truncate">{f.v}</p>
                                <span className="font-mono text-[10px] text-[#FF4040] shrink-0">{f.conf}%</span>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>

            <div className="px-4 py-2.5 border-t border-[#303030]/8 flex items-center gap-1.5 bg-[#FAFAF8]">
                <ShieldCheck className="w-3.5 h-3.5 text-[#FF4040]" />
                <span className="text-[11px] text-[#303030]/60">Confidence-scored · audit trail logged</span>
            </div>
        </div>
    );
}
